import { useTranslation } from 'react-i18next';
import { Switch } from '@headlessui/react';
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { useTheme } from '@/hooks/useTheme';

const ThemeToggle = () => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  
  const isDark = theme === 'dark';
  
  return (
    <Switch
      checked={isDark}
      onChange={toggleTheme}
      className={`${
        isDark ? 'bg-primary-600' : 'bg-gray-200'
      } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2`}
    >
      <span className="sr-only">
        {isDark ? t('settings.lightMode') : t('settings.darkMode')}
      </span>
      <span
        className={`${
          isDark ? 'translate-x-6' : 'translate-x-1'
        } flex h-4 w-4 transform items-center justify-center rounded-full bg-white transition-transform`}
      >
        {isDark ? (
          <MoonIcon className="h-3 w-3 text-primary-600" />
        ) : (
          <SunIcon className="h-3 w-3 text-amber-500" />
        )}
      </span>
    </Switch>
  );
};

export default ThemeToggle;